import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { MOBILE, FROM_TABLET, DESKTOP, TO_DESKTOP } from 'helpers/styles/media';

import FormBlock from './FormBlock';

const FormMain = ({ formRef }) => {
  return (
    <FormWrapper ref={formRef}>
      <FormBlock />
    </FormWrapper>
  );
};

const FormWrapper = styled.div`
  box-shadow: 0.4px 0.9px 26.7px 2.3px rgba(14, 19, 29, 0.12);
  border-radius: 20px;
  padding: 20px;
  background-color: #fff;
  z-index: 30;

  @media ${DESKTOP} {
    position: absolute;
    top: 289px;
    right: calc(50% - 590px);
  }

  @media ${TO_DESKTOP} {
    position: relative;
    margin: -50px auto 0;
  }

  @media ${FROM_TABLET} {
    max-width: 345px;
  }

  @media ${MOBILE} {
    max-width: 336px;
    margin-bottom: 64px;
  }
`;

FormMain.propTypes = {
  formRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.shape({ root: PropTypes.string.isRequired }),
    }),
  ]).isRequired,
};

export default FormMain;
